import { ReactNode } from "react";
import cn from "classnames";
import { InnerSpacingVariant } from "../../lib/storyblok/types/shared";
import type { RichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";
import s from "./LocalAlert.module.scss";
import c from "../../styles/container.module.scss";
import bs from "../../styles/block.spacing.module.scss";
import Markdown from "../../ui/Markdown";
import RichText from "../../ui/Common/RichText";
import { isRichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";

type Props = {
  style: "white" | "red" | "black" | "signature";
  icon: ReactNode;
  title: string;
  text: RichTextContent;
  button: ReactNode;
  padding: InnerSpacingVariant;
};

const LocalAlert = ({
  style,
  icon,
  title,
  text,
  button,
  padding = "topAndBottom",
}: Props) => {
  return (
    <div className={cn(s.localAlert, c.medium, s[style], bs[padding])}>
      <div className={s.content}>
        {icon && <span className={s.icon}>{icon && icon}</span>}
        {title && <h3 className={s.title}>{title}</h3>}
        {text && (
          <>
            {isRichTextContent(text) ? (
              <RichText
                content={text}
                alignment={"alignLeft"}
                className={s.description}
              />
            ) : (
              <Markdown>{text}</Markdown>
            )}
          </>
        )}
        {button && button}
      </div>
    </div>
  );
};

export default LocalAlert;
